import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

export const IconOFTV = () => {
  return (
    <StaticImage
      src="../oftv.png"
      layout="constrained"
      alt="OFTV Icon"
      objectFit="contain"
      formats={['png']}
      placeholder="none"
      transformOptions={{ fit: 'contain' }}
    />
  );
};
